import { Box, Tooltip, Typography } from "@mui/material";

/** A waited-on name that truncates without hiding the days suffix after it. */
export function WaitingOnName({ name, days }: { name: string; days: string }) {
  return (
    <Tooltip title={`${name}${days}`}>
      <Box sx={{ display: "flex", minWidth: 0, maxWidth: "100%" }}>
        <Typography noWrap variant="body2" sx={{ minWidth: 0 }}>
          {name}
        </Typography>
        {days && (
          <Typography variant="body2" sx={{ flexShrink: 0, whiteSpace: "pre" }}>
            {days}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}
